import React from 'react'
import styles from './headerMobileFooter.module.scss'
import PhoneNumberLink from '../../../../src/common/components/PhoneNumberLink/phonenumberlink'
import ModalTeLlamamos from '../../../../src/common/components/modal/teLlamamos/index'
import telephones from '../../constants/telephones'
import { HeaderMobileFooterProps } from '../../../../src/common/components/headers/HeaderMobileFooter'
import LanguageSelector from './LanguageSelector'
import { t } from '../../i18n'

export default function HeaderMobileFooter({
  esPath,
  caPath,
  openModal,
  goToCitaPrevia,
  setOpenModal,
}: HeaderMobileFooterProps) {
  return (
    <div className={styles.yellow_footer}>
      <div className={styles.phone}>
        <PhoneNumberLink
          countryCode={'34'}
          telephone={telephones[1].telephone}
        />
      </div>
      <div onClick={() => setOpenModal(true)} className={styles.call_you}>
        {t('home.call')}
      </div>
      <ModalTeLlamamos setOpenModal={setOpenModal} openModal={openModal} />
      <div onClick={goToCitaPrevia} className={styles.calendar}>
        {t('taller-card.appointment')}
      </div>
      <LanguageSelector caPath={caPath} esPath={esPath} />
    </div>
  )
}
